var _path, _rect, _path2, _rect2, _path3, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06055 16.65C6.06055 16.291 6.36554 16 6.74176 16H19.3181C19.6943 16 19.9993 16.291 19.9993 16.65C19.9993 17.009 19.6943 17.3 19.3181 17.3H6.74176C6.36554 17.3 6.06055 17.009 6.06055 16.65Z",
    fill: "#096DD9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 18.35,
    width: 3.7,
    height: 3.7,
    rx: 1.85,
    transform: "rotate(-90 0.65 18.35)",
    stroke: "#096DD9",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06055 2.65C6.06055 2.29101 6.36554 2 6.74176 2H19.3181C19.6943 2 19.9993 2.29101 19.9993 2.65C19.9993 3.00899 19.6943 3.3 19.3181 3.3H6.74176C6.36554 3.3 6.06055 3.00899 6.06055 2.65Z",
    fill: "#096DD9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 4.35,
    width: 3.7,
    height: 3.7,
    rx: 1.85,
    transform: "rotate(-90 0.65 4.35)",
    stroke: "#096DD9",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06055 9.65C6.06055 9.29101 6.36554 9 6.74176 9H19.3181C19.6943 9 19.9993 9.29101 19.9993 9.65C19.9993 10.009 19.6943 10.3 19.3181 10.3H6.74176C6.36554 10.3 6.06055 10.009 6.06055 9.65Z",
    fill: "#096DD9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 11.35,
    width: 3.7,
    height: 3.7,
    rx: 1.85,
    transform: "rotate(-90 0.65 11.35)",
    stroke: "#096DD9",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.a9ab2e76f12f5afbf0f29fdf67030991.svg";
export { ForwardRef as ReactComponent };